export interface IItem {
  key: string;
  value: string;
}

export const sort: string = 'id,DESC';
export const sortByPos: string = 'posProductName,DESC';
export const sortByWeb: string = 'webProductName,DESC';
